module.exports = __webpack_public_path__ + "65096beecacfaa44fcc7e7cd6bfadd7e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-22.png
// module id = 2039
// module chunks = 0